module.exports = __webpack_public_path__ + "ubuntu-mediumitalic-webfont.4bcd70b50bfb3d461a58.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-mediumitalic-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-mediumitalic-webfont.woff2
// module chunks = styles